import { useTranslation } from 'react-i18next';
import { PRODUCT_TYPE_CHANGE_ITEM_KEYS } from './productTypeChange';

function ProductTypeChangeWarning() {
  const { t } = useTranslation('product-information');
  return (
    <div className="product-type-change-warning">
      <p className="product-type-change-warning__intro">{t('PRODUCT_TYPE_CHANGE.INTRO')}</p>
      <ul className="product-type-change-warning__list">
        {PRODUCT_TYPE_CHANGE_ITEM_KEYS.map((itemKey) => (
          <li key={itemKey}>{t(`PRODUCT_TYPE_CHANGE.ITEMS.${itemKey}`)}</li>
        ))}
      </ul>
      <p className="product-type-change-warning__irreversible">{t('PRODUCT_TYPE_CHANGE.IRREVERSIBLE')}</p>
    </div>
  );
}

export default ProductTypeChangeWarning;
